import { render, staticRenderFns } from "./SaveBar.vue?vue&type=template&id=45c121fe&scoped=true"
import script from "./SaveBar.vue?vue&type=script&lang=ts"
export * from "./SaveBar.vue?vue&type=script&lang=ts"
import style0 from "./SaveBar.vue?vue&type=style&index=0&id=45c121fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c121fe",
  null
  
)

export default component.exports